<template>
    <section>
        <div class="max-w-screen-xl mx-auto px-4 mb-20">
            <!-- Header Section -->
            <div class="max-w-max mx-auto relative mb-8">
                <NuxtImg src="/images/circuit.png" width="298" height="180" alt="Shopping Bag"
                    class="w-40 sm:w-56 md:w-72 lg:w-[298px] h-auto" loading="lazy" />
                <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 
                 inline-flex items-center justify-center 
                 w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 
                 rounded-2xl bg-[image:var(--primary-gradient)]">
                    <NsCloudIcon class="w-6 sm:w-8 md:w-10 h-auto" />
                </div>
            </div>

            <!-- Heading -->
            <h2 class="text-xl sm:text-2xl md:text-3xl text-[var(--text-secondary)] 
               text-center mx-auto font-bold -mt-4 sm:-mt-6 md:-mt-7 mb-4 px-2">
                Speed and Flexibility with Headless Technology
            </h2>
            <p class="text-sm sm:text-base md:text-lg lg:text-xl text-[var(--text-gray)] 
               max-w-4xl text-center mx-auto mb-10 px-2">
                Enjoy the freedom to deliver dynamic, responsive content on every device.
                Our headless approach decouples the frontend, ensuring rapid load times,
                smooth user experiences, and full customization for your brand.
            </p>

            <!-- Feature Cards -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10">
                <Card unstyled v-for="(feature, i) in features" :key="i"
                    class="relative rounded-2xl shadow-md hover:shadow-lg transition">
                    <!-- Show 'Most Popular' Tag on Center Card -->
                    <Tag v-if="i === 1" value="Most Popular" severity="success" class="absolute -top-3 left-1/2 -translate-x-1/2 
                   bg-[var(--primary-full)] text-black 
                   font-semibold px-3 py-1 rounded-full shadow-md text-sm sm:text-base" />

                    <!-- Header -->
                    <template #header>
                        <NuxtImg :src="feature.image" height="320" width="428" alt="feature image"
                            class="w-full h-auto object-cover rounded-t-2xl mb-4" loading="lazy" />
                    </template>

                    <!-- Title -->
                    <template #title>
                        <h3 class="text-lg sm:text-xl md:text-2xl text-[var(--text-secondary)] 
                     font-bold px-4 mb-2">
                            {{ feature.title }}
                        </h3>
                    </template>

                    <!-- Content -->
                    <template #content>
                        <div class="px-4 pb-6">
                            <p class="text-[var(--text-gray)] text-sm sm:text-base mb-4 leading-relaxed lg:min-h-12">
                                {{ feature.description }}
                            </p>
                            <Button unstyled label="Learn More" iconPos="left" class="group !rounded-xl !px-4 sm:!px-5 
         bg-[image:var(--primary-gradient)] hover:bg-[image:var(--primary-gradient-reverse)]
         transition-all duration-1000 ease-in-out
         !py-2.5 sm:!py-3 font-semibold
         text-[var(--text-secondary)] 
         flex items-center justify-center gap-2 sm:gap-3 
         w-full sm:w-auto text-sm sm:text-base overflow-hidden">

                                <span class="flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 
             rounded-full bg-white 
             transform transition-all duration-1000 ease-in-out 
             group-hover:translate-x-28">
                                    <i class="pi pi-angle-right text-green-500 font-bold text-sm sm:text-lg"></i>
                                </span>
                                <span class="transition-all duration-1000 ease-in-out group-hover:-translate-x-1/2">
                                    Learn More
                                </span>
                            </Button>
                        </div>
                    </template>
                </Card>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">

const NsCloudIcon = defineAsyncComponent(() =>
    import("~/components/atoms/icons/NsCloudIcon.vue")
);

const features = [
    {
        title: "Responsive Design",
        description: "Optimized for mobile, tablet, and desktop.",
        image: "/images/responsive-design.png",
    },
    {
        title: "Dynamic Content",
        description: "Manage and display content without limitations.",
        image: "/images/dynamic-content.png",
    },
    {
        title: "Scalable Architecture",
        description: "Grow your platform seamlessly.",
        image: "/images/scalable-architecture.png",
    },
];
</script>
